import cn from 'classnames';
import IconLoading from 'components/Common/Icons/IconLoading';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store';
import fetchStudioSearchResultsOperation from 'store/studioSearch/operation/fetchStudioSearchResultsOperation';
import getSearchResultsFetched from 'store/studioSearch/selector/getSearchResultsFetched';
import getStudioSearchPageNr from 'store/studioSearch/selector/getStudioSearchPageNr';
import getStudioTotalResultsAvailable from 'store/studioSearch/selector/getStudioTotalResultsAvailable';
import isMoreSearchResultsToFetch from 'store/studioSearch/selector/isMoreSearchResultsToFetch';
import isStudioSearchLoading from 'store/studioSearch/selector/isStudioSearchLoading';
import styles from './LoadMoreItems.module.scss';

const LoadMoreItems = () => {
  const dispatch = useAppDispatch();
  const moreResultsToLoad = useSelector(isMoreSearchResultsToFetch);
  const fetchedResults = useSelector(getSearchResultsFetched);
  const totalResults = useSelector(getStudioTotalResultsAvailable);
  const isLoading = useSelector(isStudioSearchLoading);
  const pageNr = useSelector(getStudioSearchPageNr);
  const [fetchingPage, setFetchingPage] = useState(false);
  const { t } = useTranslation();

  const progressStyles = {
    transform: `translateX(${Math.round(fetchedResults / (totalResults * 100)) - 100}%)`,
  };

  useEffect(() => {
    if (isLoading && fetchingPage) {
      return () => {
        setFetchingPage(false);
      };
    }
    return () => {};
  }, [isLoading, fetchingPage]);

  const loadMoreClick = () => {
    dispatch(fetchStudioSearchResultsOperation(pageNr + 1));
  };

  const resultsShowing = {
    number: fetchedResults,
    total: totalResults,
  };

  if (!moreResultsToLoad) {
    return null;
  }

  return (
    <div className={styles.loadMoreItems}>
      <OpText block variant="body-large-regular">
        {t('txt_designs_showing', resultsShowing)}
      </OpText>
      <div className={styles.progressBar}>
        <div className={styles.levelIndicator} style={progressStyles} />
      </div>
      <OpButton
        className={cn(styles.loadMoreButton, { [styles.hidden]: fetchingPage })}
        size="large"
        variant="primary"
        onClick={loadMoreClick}
      >
        {fetchingPage && <IconLoading className={styles.loadingIcon} />}
        {t('toggle_show_more_orderflow')}
      </OpButton>
    </div>
  );
};

export default LoadMoreItems;
